<script>

export default {
  name: "AssaySell",
  data() {
    return {
      data: [],
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      tableKey: 0,
      loading: false,
      coalShopName: '',
    }
  },
  mounted() {
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const params = {
        pageNum: this.page.current,
        pageSize: this.page.size,
        coalShopName: this.coalShopName || undefined
      }
      this.$axios.post('/laboratory/report_release/queryCoalSourcePage', params).then((res) => {
        this.$set(this, 'loading', false)
        this.$set(this, 'data', res.data.data.list)
        this.$set(this.page, 'total', res.data.data.total)
        this.tableKey += 1
      }).catch(() => {
        this.$set(this, 'loading', false)
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    fetchInit() {
      this.page.current = 1
      this.init()
    },
    handleUpdateHot(row, type) {
      const params = {
        coalShopId: row.coalShopId,
        hot: type
      }
      this.$axios.post('/laboratory/report_release/coalSourceHot', params).then(() => {
        this.$message.success({ showClose: true, message: type === 'Y' ? '标记火热成功' : '撤销火热成功' })
        this.init()
      })
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="margin-bottom: 10px;">
      <div class="fl" style="font-size: 16px; display: flex; align-items: center; height: 32px;">
        煤源火热标记
        <el-input v-model="coalShopName" size="mini" placeholder="输入煤源" style="margin: 0 10px; width: 200px" clearable
          @change="fetchInit"></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="85%" v-loading="loading" highlight-current-row
      :key="tableKey">
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column type="index" label="序号" width="50" align="center" show-overflow-tooltip />
      <el-table-column prop="coalShopName" label='煤源' minWidth="100" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="hot" label="是否火热" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.hot === 'Y'" type="success" size="mini">是</el-tag>
          <el-tag v-else type="danger" size="mini">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label='操作' width="100" align="center" fixed="right">
        <template #default="scope">
          <el-popconfirm v-if="scope.row.hot === 'N'" trigger="click" @confirm="handleUpdateHot(scope.row, 'Y')"
            title="确定 标记 该煤源吗？">
            <template #reference>
              <el-button size="mini" type="text">标记</el-button>
            </template>
          </el-popconfirm>
          <el-popconfirm v-if="scope.row.hot === 'Y'" trigger="click" @confirm="handleUpdateHot(scope.row, 'N')"
            title="确定 撤销 该煤源吗？">
            <template #reference>
              <el-button size="mini" type="text" style="color: #F56C6C">撤销</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200, 500, 1000]" :page-size="page.size" :total="page.total" background
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped></style>
